import {
  AllowStringForNumbers,
  BatteryInstall,
  BatterySpec,
  BatterySummary,
} from "@inrange/building-manager-api-client/models-site";
import formatCurrency from "./formatCurrency";

export const formatBatterySpec = (spec: BatterySpec) => {
  if (spec.capacityMwh <= 1) {
    return `${(spec.powerMw * spec.count! * 1000).toFixed(1)} kW / ${(spec.capacityMwh * spec.count! * 1000).toFixed(1)} kWh`;
  }
  return `${spec.powerMw} MW / ${spec.capacityMwh} MWh`;
};

export const formatBatterySummary = (summary: BatterySummary) => {
  if (summary.capacityMwh <= 1) {
    return `${(summary.powerMw * 1000).toFixed(1)} kW / ${(summary.capacityMwh * 1000).toFixed(1)} kWh`;
  }
  return `${summary.powerMw} MW / ${summary.capacityMwh} MWh`;
};

export const formatBatteryModel = (
  install: AllowStringForNumbers<BatteryInstall> | BatterySpec
) => {
  return parseFloat(install.count! as unknown as string) > 1
    ? `${install.modelName || "Custom"} x ${install.count}`
    : `${install.modelName || "Custom"}`;
};

export const formatLeaseTariff = (
  tariff: number,
  billingFrequency: string,
  currencyCode: string
): string => {
  if (billingFrequency === "monthly") {
    return formatCurrency(tariff / 12, currencyCode, 2, false);
  } else if (billingFrequency === "quarterly") {
    return formatCurrency(tariff / 4, currencyCode, 2, false);
  } else {
    return formatCurrency(tariff, currencyCode, 2, false);
  }
};

export const formatLeaseTariffBillingFrequency = (
  billingFrequency: string
): string => {
  return billingFrequency.charAt(0).toUpperCase() + billingFrequency.slice(1);
};

export const formatddMMyyyy = (dateString: string): string => {
  return new Date(dateString).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "UTC",
  });
};
